import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-images.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
class EGDSImage extends React.Component {
  static displayName = 'EGDSImage';
  static defaultProps = {
    blankDefault: false,
    src: ''
  };
  constructor(props) {
    super(props);
    this.state = {
      hideImage: false,
      hidePlaceholderImage: false
    };
    this.handleError = this.handleError.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
  }
  shouldComponentUpdate(nextProps) {
    const {
      hideImage
    } = this.state;
    if (nextProps.src && hideImage === true) {
      // This manually triggers an update and then forces a false to prevent a loop
      this.setState({
        hideImage: false
      });
      return false;
    }
    return true;
  }
  handleError(event) {
    const {
      blankDefault,
      placeholderImage,
      additionalProps
    } = this.props;
    this.setState({
      hideImage: !!placeholderImage || !!blankDefault
    });
    if (additionalProps) {
      // To get around TypeScript error "Property does not exist on type object"
      const castedProps = additionalProps;
      if (castedProps.onError && typeof castedProps.onError === 'function') {
        castedProps.onError(event);
      }
    }
  }
  handleSuccess(event) {
    const {
      additionalProps
    } = this.props;
    if (!additionalProps?.['data-lazy']) {
      this.setState({
        hidePlaceholderImage: true
      });
    }
    if (additionalProps) {
      // To get around TypeScript error "Property does not exist on type object"
      const castedProps = additionalProps;
      if (castedProps.onLoad && typeof castedProps.onLoad === 'function') {
        castedProps.onLoad(event);
      }
    }
  }
  render() {
    const {
      blankDefault,
      className,
      placeholderImage,
      alt,
      src,
      imgRef,
      lazyLoading,
      additionalProps
    } = this.props;
    const {
      hideImage,
      hidePlaceholderImage
    } = this.state;
    const imageClasses = getClassNameList('uitk-image-media', className);
    const placeholderClass = getClassNameList('uitk-image-placeholder', {
      [`uitk-image-placeholder-image`]: placeholderImage && !blankDefault && !hidePlaceholderImage
    });
    const lowerCaseAttributes = Object.fromEntries(Object.entries(additionalProps || {}).map(([key, value]) => [key.toLowerCase(), value]));
    const imageProps = {
      className: imageClasses,
      ref: imgRef,
      src,
      ...lowerCaseAttributes
    };
    return jsx("div", {
      className: placeholderClass,
      children: !hideImage && jsx("img", {
        alt: alt,
        ...imageProps,
        onError: this.handleError,
        onLoad: this.handleSuccess,
        loading: lazyLoading === 'off' ? undefined : lazyLoading
      })
    });
  }
}
export { EGDSImage };